export function formatEnumValue(
  value: string | null | undefined,
  separator = "_"
): string {
  if (!value) return "";
  return value
    .toLowerCase()
    .split(separator)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
